import { cn } from '../../utils/cn';

interface LogoProps {
  className?: string;
  variant?: 'full' | 'icon';
}

export default function Logo({ className, variant = 'full' }: LogoProps) {
  if (variant === 'icon') {
    return (
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn('h-8 w-8', className)}
      >
        <defs>
          <linearGradient id="logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6366f1" />
            <stop offset="50%" stopColor="#8b5cf6" />
            <stop offset="100%" stopColor="#06b6d4" />
          </linearGradient>
        </defs>
        <rect x="4" y="8" width="6" height="16" rx="2" fill="url(#logo-gradient)" />
        <rect x="13" y="6" width="6" height="20" rx="2" fill="url(#logo-gradient)" opacity="0.85" />
        <rect x="22" y="10" width="6" height="14" rx="2" fill="url(#logo-gradient)" opacity="0.7" />
      </svg>
    );
  }
  
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-8 w-8"
      >
        <defs>
          <linearGradient id="logo-gradient-full" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6366f1" />
            <stop offset="50%" stopColor="#8b5cf6" />
            <stop offset="100%" stopColor="#06b6d4" />
          </linearGradient>
        </defs>
        <rect x="4" y="8" width="6" height="16" rx="2" fill="url(#logo-gradient-full)" />
        <rect x="13" y="6" width="6" height="20" rx="2" fill="url(#logo-gradient-full)" opacity="0.85" />
        <rect x="22" y="10" width="6" height="14" rx="2" fill="url(#logo-gradient-full)" opacity="0.7" />
      </svg>
      <span className="text-xl font-bold text-text-primary">kolumi</span>
    </div>
  );
}
